export const REVIEW_ROUTES = {
  __ROOT__: '/review',
}
